import { Header, CourseDiscSection, AboutTeacher, DepartmentCourse, Trophy, RatingCourse, SliderRow } from "../../app/features/AboutCourse"
import { useParams } from "react-router-dom";
import Dots from '../../Components/Loader/Dots';
import { Fade } from "react-reveal";
import { Section } from "./StyledPage";
import { useSelector } from "react-redux";
import { GET_REQUEST } from "../../HooksApi/useApi";
import UseGetData from "../../HookAxios/getdata";
const AboutCoursePAge = () => {
    const token = useSelector((state) => state.Auth.userInfo.token)
    console.log("the token is ", token)
    const { idCourse } = useParams()
    const { isLoading: LoadAboutCourse, data: dataAboutCourse }
        = GET_REQUEST({
            queryKey: `aboutCourse${idCourse}`,
            request: () => UseGetData('get_course_by_id', { id: idCourse }, { "Authorization": `Bearer ${token}` }),
            enabled: true
        })
    return (
        <>
            {
                !LoadAboutCourse && dataAboutCourse?.data?.data?.courses ?
                    <>
                        <Header
                            name={dataAboutCourse?.data?.data.name}
                            disc={dataAboutCourse?.data?.data.brief}
                            image={dataAboutCourse?.data?.data.image_path}
                            rate={dataAboutCourse?.data?.data.rate}
                            teacher_name={dataAboutCourse?.data?.data.teacher_name}
                            numberRate={dataAboutCourse?.data?.data.number_of_rater}
                            dateCreate={dataAboutCourse?.data?.data.date_of_create}
                            numberStudent={dataAboutCourse?.data?.data.number_of_student}
                            subscribe={dataAboutCourse?.data?.data?.is_subscribtion}
                        />
                        <Section>
                            <Fade>
                                <CourseDiscSection
                                    data={dataAboutCourse?.data?.data?.courses}
                                />
                            </Fade>
                            <Fade>
                                {/* <DepartmentCourse
                                        LoadDepartments={LoadDepartments}
                                        dataDepartments={dataDepartments}
                                    /> */}
                            </Fade>
                        </Section>
                        {/* <SliderRow data={DataCards} title='دورات مشابهة' link='/' /> */}
                    </>
                    // ))

                    : <Dots />
            }
        </>
    )
}
export default AboutCoursePAge